import { render, staticRenderFns } from "./zhuduAccessRecords.vue?vue&type=template&id=00f8fac4&scoped=true"
import script from "./zhuduAccessRecords.vue?vue&type=script&lang=js"
export * from "./zhuduAccessRecords.vue?vue&type=script&lang=js"
import style0 from "./zhuduAccessRecords.vue?vue&type=style&index=0&id=00f8fac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f8fac4",
  null
  
)

export default component.exports